/**
 * Impersonation ("view as user"): swap the admin's session for a short-lived
 * impersonation token, remembering the original admin session so it can be
 * restored with one click. State lives in localStorage so a global banner can
 * render it anywhere in the app.
 */

const KEYS = {
  flag: 'impersonation',        // JSON { name, adminToken, adminUser }
  token: 'authToken',
  user: 'currentUser',
};

export const isImpersonating = () => Boolean(localStorage.getItem(KEYS.flag));

export const impersonationInfo = () => {
  try {
    return JSON.parse(localStorage.getItem(KEYS.flag) || 'null');
  } catch {
    return null;
  }
};

/**
 * Enter impersonation. Saves the current admin token/user, installs the
 * impersonation token + target user, then hard-navigates into the app as them.
 */
export const startImpersonation = (impersonationToken, targetUser) => {
  const adminToken = localStorage.getItem(KEYS.token);
  const adminUser = localStorage.getItem(KEYS.user);
  const name = `${targetUser?.first_name || ''} ${targetUser?.last_name || ''}`.trim() || targetUser?.email || 'user';

  localStorage.setItem(KEYS.flag, JSON.stringify({ name, adminToken, adminUser }));
  localStorage.setItem(KEYS.token, impersonationToken);
  localStorage.setItem(KEYS.user, JSON.stringify(targetUser));
  window.location.assign('/user/dashboard');
};

/** Restore the admin session and return to the admin users page. */
export const stopImpersonation = () => {
  const info = impersonationInfo();
  if (info?.adminToken) localStorage.setItem(KEYS.token, info.adminToken);
  if (info?.adminUser) localStorage.setItem(KEYS.user, info.adminUser);
  localStorage.removeItem(KEYS.flag);
  window.location.assign('/admin/users');
};
